<template>
  <div>
    <div style="margin-top: 2rem">Redirect to Slingshot mobile app...</div>
  </div>
</template>

<script>

export default {
  name: 'MobileDeepLink',
  props: {
    msg: String
  },
  data () {
    return {
      mTarget: ''
    }
  },
  computed: {
    navigatorAgent() {
      return navigator.userAgent
    },
    isAndroid() {
      return (/Android/i.test(this.navigatorAgent))
    },
    isIOS() {
      return (/iPad|iPhone|iPod/i.test(this.navigatorAgent))
    },
    isMac() {
      return (/Mac/i.test(this.navigatorAgent)) && !this.isIOS
    },
    isBrowserChrome() {
      if (this.isMac) {
        return (/chrome|chromium|crios/i.test(this.navigatorAgent))
      } else if (this.isIOS || this.isAndroid) {
        return (/chrome|chromium|crios/i.test(this.navigatorAgent)) &&
            !(/EdgA/i.test(this.navigatorAgent))
      } else {
        return (/chrome|chromium|crios/i.test(this.navigatorAgent))
      }
    },
    isBrowserSafari() {
      if (this.isMac) {
        return (/Safari/i.test(this.navigatorAgent)) &&
            !(/chrome|chromium|crios/i.test(this.navigatorAgent))
      } else if (this.isIOS || this.isAndroid) {
        return (/Safari/i.test(this.navigatorAgent)) &&
            !(/chrome|chromium|crios/i.test(this.navigatorAgent)) &&
            !(/firefox|fxios/i.test(this.navigatorAgent))
      } else {
        return (/Safari/i.test(this.navigatorAgent))
      }
    },
    isBrowserFirefox() {
      if (this.isMac) {
        return (/firefox|fxios/i.test(this.navigatorAgent))
      } else if (this.isIOS || this.isAndroid) {
        return (/firefox|fxios/i.test(this.navigatorAgent))
      } else {
        return (/firefox|fxios/i.test(this.navigatorAgent))
      }
    },
    isBrowserEdge() {
      if (this.isMac) {
        return (/EdgA/i.test(this.navigatorAgent))
      } else if (this.isIOS || this.isAndroid) {
        return (/EdgA/i.test(this.navigatorAgent))
      } else {
        return (/EdgA/i.test(this.navigatorAgent))
      }
    },
    supportedDomain() {
      return [
        'slingshot-mobile-app.web.app'
      ]
    },
    supportedTargets() {
      return [
        'scan-wifi-network',
        'setup-payment-assistant',
        'setup-automatic-payment',
        'payments',
        'services',
        'usage',
        'power-signup',
        'mobile-signup',
        'broadband-signup'
      ]
    },
    getPackageName() {
      return "nz.co.slingshot.app.slingshot"
    },
    getAppId() {
      return "1580478424"
    },
    getAppStoreUrl() {
      if (this.isIOS || this.isMac) {
        return "https://apps.apple.com/app/slingshot/id" + this.getAppId;
      } else {
        return "https://play.google.com/store/apps/details?id=" + this.getPackageName;
      }
    },
    getCustomSchemeUrl() {
      if (this.isAndroid) {
        return "intent://" + this.getPackageName + "/#Intent;scheme=myaccount;package=" + this.getPackageName + ";end";
      } else if (this.isIOS) {
        return this.getPackageName + "://";
      } else {
        return this.getAppStoreUrl;
      }
    },
    getAssociateUrl() {
      const hostDomain = this.supportedDomain[0];
      if (this.isAndroid) {
        return "intent://" + hostDomain + "/#Intent;scheme=https;package=" + this.getPackageName + ";end";
      } else {
        return this.getAppStoreUrl;
      }
    },
    isCloseWindow() {
      let close = false
      if (this.isAndroid) {
        /*
        For android:
          1. Chrome no close action required
          3. Opera browser falls under chrome during testing
         */
        close = (!this.isBrowserChrome)
      } else if (this.isIOS) {
        if (this.isBrowserSafari) {
          /*
          For ios safari:
           1. if app does not exist host redirect will be initiated and retained
              hence we need to close it after we open app store
           */
          close = true
        } else if (this.isBrowserChrome) {
          /*
          For ios chrome:
           1. if app does not exist host redirect will be initiated but replaced with store url
              this behavior is the same on Android
           2. if app exists, chrome opens the App but leaves behind a new empty tab
           */
        } else if (this.isBrowserFirefox) {
          /*
          For ios firefox:
           1. if app does not exist host redirect will be initiated and retained
              hence we need to close it after we open app store
           2. if app exists, chrome opens the App but leaves behind a new empty tab
           */
          close = true
        } else {
          /*
          By default we will close host
          1. Opera browser falls under Safari during testing.
           */
          close = true
        }
      }
      return close
    },
  },
  mounted() {
    const vm = this
    vm.mTarget = vm.$route.query.target;
    if (vm.supportedTargets.includes(vm.mTarget)) {
      vm.onOpenSlingshotAssociated()
    } else {
      window.location.replace("https://www.slingshot.co.nz/");
    }
  },
  methods: {
    onOpenCustomSchemeUrl() {
      const vm = this
      console.log("onOpenCustomSchemeUrl")

      const url = vm.getCustomSchemeUrl;
      window.location.replace(url);
    },
    onOpenSlingshotAssociated() {
      const vm = this
      console.log("onOpenSlingshotAssociated")

      const url = vm.getAssociateUrl;
      window.location.replace(url);

      if (vm.isCloseWindow) {
        // delay to avoid closing too fast
        setTimeout(function() {
          window.close()
        }, 600);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.clickable {
  cursor: pointer;
}
.link {
  width: 16rem;
  margin-left: auto;
  margin-right: auto;
  padding-top: 6px;
  padding-bottom: 6px;
  border-style: solid;
  border-width: 1px;
  border-color: darkgray;
  border-radius: 4px;
  cursor: pointer;
}
</style>
